import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "py-8 text-center" }, "This user is yet to run any Training Events", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { PropType, ref } from "vue";

import EventsTable from "../tables/EventsTable.vue";

import api from "@/api/api";
import { Event, User } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserEvents',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;



const events = ref([] as Event[]);
events.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.users.getEventsByUser(props.user.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.events;

return (_ctx: any,_cache: any) => {
  return (events.value.length)
    ? (_openBlock(), _createBlock(EventsTable, {
        key: 0,
        events: events.value
      }, null, 8, ["events"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})